const LOAD_TAGS_FETCH = "tags::fetch";
const LOAD_TAGS_SUCCESS = "tags::fetch::success";
const UNLOAD_TAGS = "tags::unload";

function fetchTagsAction(args) {
  const { resolve, reject } = args;

  return {
    type: LOAD_TAGS_FETCH,
    payload: {
      resolve,
      reject,
    },
  };
}

const unloadTagsAction = { type: UNLOAD_TAGS };

export {
  fetchTagsAction,
  unloadTagsAction,
  LOAD_TAGS_FETCH,
  LOAD_TAGS_SUCCESS,
  UNLOAD_TAGS,
};
